import * as cloudInvoicing from "./cloud-invoicing/index"
export default [cloudInvoicing]


// WEBPACK FOOTER //
// ./src/store/modules/bill-management/index.js